const exhibitionList = document.querySelector('.exhibitions-list');

if (exhibitionList) {
  const urlParams = ['locations', 'types', 'audiences', 'pageNumber'];

  const getExtraFormDataInput = (parent, searchInput) => ({
    searchTerm: searchInput || getSearchedData(parent),
    postType: parent.querySelector('[data-post-type]').value,
    stopSlider: parent.querySelector('[data-stop-slider]')?.value || '',
    locations: getCheckedData(parent, 'locations'),
    types: getCheckedData(parent, 'types'),
    audiences: getCheckedData(parent, 'audiences'),
  });

  // Filter click
  attachEvent('.exhibitions-list .mod-filter .dropdown__list-item input', 'click', (ev) => {
    const parent = ev.target.closest('.exhibitions-list');
    axiosGetPaginateAndFilteredPosts(parent, 1, urlParams, getExtraFormDataInput(parent));
  });

  // Pagination
  attachEvent('.exhibitions-list .pagination .page-numbers', 'click', (ev) => {
    const parent = ev.target.closest('.exhibitions-list');
    ev.preventDefault();
    axiosGetPaginateAndFilteredPosts(parent, ev.target.dataset.page, urlParams);
  });
}
